import {
	whiteColor,
	blackColors,
	blackColor,
	primaryColor,
	hexToRgb,
	dangerColor,
	greyColor,
} from 'assets/jss/material-dashboard-pro-react';

const iconStyle = {
	height: '16px',
	width: 'auto',
	maxWidth: '16px',
	color: blackColors[3],
};
const alternativeSelectStyle = (theme) => ({
	alternativeSelectWrapper: {
		position: 'relative',
	},
	alternativeSelect: {
		margin: '16px 0',
	},
	alternativeSelectMD: {},
	selectedItemWrapperWithPadding: {
		paddingLeft: '8px!important',
		paddingRight: '8px!important',
	},
	selectedItemWrapper: {
		width: '100%',
		backgroundColor: whiteColor,
		borderTopLeftRadius: '4px',
		borderTopRightRadius: '4px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '8px 8px 5px 8px',
		position: 'relative',
		zIndex: 10,
		transition: 'all .1s ease-in-out',
	},
	selectedItemWrapperSM: ({ sizes: { sm } }) => ({
		height: sm,
		padding: '8px 0 5px 0',
		borderBottom: `1px solid ${blackColors[3]}`,
	}),
	selectedItemWrapperMD: {
		height: 72,
		boxShadow: `0 8px 8px -6px rgba(${hexToRgb(blackColor)}, 0.5)`,
	},
	selectedItemWrapperDisabled: {
		borderBottom: `2px solid ${blackColors[4]} !important`,
	},
	selectedItemWrapperError: {
		borderBottom: `2px solid ${dangerColor[0]}!important`,
	},
	selectedItemWrapperOpen: {
		borderBottomColor: 'transparent',
	},
	arrowIcon: {
		color: blackColors[3],
		marginBottom: '3px',
		transition: 'all .3s ease-in-out',
	},
	customArrowIcon: {
		marginBottom: '3px',
		transition: 'all .3s ease-in-out',
	},
	arrowIconSM: {
		width: '16px',
		height: '16px',
	},
	arrowIconMD: {
		width: 24,
		height: 24,
	},
	rotatedArrowIcon: {
		transform: 'rotate(180deg)',
	},
	select: {
		height: 0,
		overflow: 'hidden',
		width: '100%',
		position: 'absolute',
		backgroundColor: whiteColor,
		left: 0,
		zIndex: 999,
	},
	selectSM: {
		top: 40,
	},
	selectMD: {
		top: 72,
	},
	open: {
		overflowY: 'scroll',
		boxShadow:
			'0 7px 8px 0 rgba(0, 0, 0, 0.054), 0 5px 22px 4px rgba(0, 0, 0, 0.036), 0 12px 17px 2px rgba(0, 0, 0, 0.042)',
		paddingTop: '10px',
		paddingBottom: '8px',
	},
	loading: {
		paddingTop: 0,
		paddingBottom: 0,
	},
	error: {
		marginTop: '4px',
	},
	menuItem: {
		transition: 'all .1s ease-in-out',
		padding: '0 36px 0  8px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		userSelect: 'none',
		position: 'relative',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
			textAlign: 'left',
		},
		'& > svg': {
			display: 'none',
			width: '16px',
			height: '16px',
			color: primaryColor[0],
		},
		'& > div': {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
		},
	},
	menuItemSM: {
		height: 40,
	},
	menuItemMD: {
		height: 48,
	},
	menuItemDisabled: {
		'&:hover': {
			cursor: 'not-allowed',
		},
		'& > div > p': {
			color: 'rgba(0, 0, 0, 0.45)',
		},
	},
	activeMenuItem: {
		backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
	},
	selectedMenuItem: {
		backgroundColor: blackColors[6],
		'& > svg': {
			display: 'block',
			position: 'absolute',
			top: '50%',
			right: '10px',
			transform: 'translateY(-50%)',
		},
	},
	selectedMenuItemSM: {},
	selectedMenuItemMD: {
		'& > svg': {
			width: 24,
			height: 24,
		},
	},
	itemIconWrapperDisabled: {
		'& p': {
			color: `${blackColors[3]} !important`,
		},
	},
	itemIconWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 0,
		marginRight: '8px',
		'& svg': {
			color: blackColors[4],
		},
		'& img': {
			width: 'auto',
		},
	},
	itemIconWrapperSM: {
		'& svg': {
			width: '16px',
			height: '16px',
		},
		'& img': {
			height: '16px',
		},
	},
	itemIconWrapperMD: {
		'& svg': {
			width: '40px !important',
			height: '40px !important',
		},
		'& img': {
			height: '40px !important',
			width: '40px !important',
		},
	},
	label: {
		marginBottom: '8px',
	},
	noResults: {
		padding: '0 8px',
		display: 'flex',
		alignItems: 'center',
	},
	closeIcon: {
		width: '16px',
		height: '16px',
		color: blackColors[3],
		cursor: 'pointer',
	},
	itemDisabledLoading: {
		marginLeft: '5px',
	},
	alternativeSelectWrapperWithBorder: {
		borderBottom: 'none',
		border: `1px solid ${greyColor} !important`,
	},
	searchInputWrapper: {
		position: 'relative',
		paddingLeft: '8px',
		paddingRight: '8px',
		'& .MuiFormControl-root': {
			marginTop: '-10px',
		},
		'& .MuiInputLabel-root': {
			paddingLeft: '20px',
		},
		'& .MuiInputLabel-shrink': {
			display: 'none',
		},
		'& .MuiInputBase-input': {
			paddingLeft: '20px',
		},
	},
	searchIcon: {
		...iconStyle,
		position: 'absolute',
		top: '25px',
		left: '8px',
	},
});

export default alternativeSelectStyle;
